import React from 'react'
import { generatePath } from 'react-router-dom'
import ExteriorFacade from 'portal/views/ExteriorFacade/ExteriorFacade'
import { RouterConfigItem } from 'portal/routes/types'


export const ExteriorFacadeRoute: RouterConfigItem = {
  path: '/exteriorFacade',
  name: 'ExteriorFacade',
  title: '外立面',
  render() {
    return (<ExteriorFacade />)
  },
  formatUrl() {
    return generatePath(this.path)
  },
}

export default [
  ExteriorFacadeRoute,
]
